import { ArrowIcon } from '@modusign/design-system';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { postponePasswordChange } from '@app/store/account/password/actions';
import { modalClose } from '@app/store/modal/actions';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  onModalClose: PropTypes.func,
  onPostPone: PropTypes.func,
};

const defaultProps = {
  onModalClose() {},
  onPostPone() {},
};

export class AccountPasswordChangeRecommendationModalComponent extends Component {
  constructor(props) {
    super(props);

    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handlePostpone = this.handlePostpone.bind(this);
  }

  handleChangePassword() {
    const { history, onModalClose } = this.props;
    onModalClose();
    history.push('/settings/profile');
  }

  handlePostpone() {
    const { onModalClose, onPostPone } = this.props;
    onModalClose();
    onPostPone();
  }

  render() {
    return (
      <div className="Container Container--max-xxs">
        <div className="Card Card--pop align-center box-6x">
          <h4>
            <strong>비밀번호 변경</strong>
          </h4>
          <p className="space-5x">
            더 안전한 전자계약을 위해
            <br />
            6개월마다 비밀번호를 변경해 주세요.
          </p>
          <button
            className="Btn Btn--md"
            name="nextTime"
            type="button"
            onClick={this.handlePostpone}
          >
            다음에 변경
          </button>
          <button
            className="Btn Btn--primary"
            name="changePassword"
            type="button"
            onClick={this.handleChangePassword}
          >
            지금 변경하기
            <ArrowIcon direction="right" ml="2px" />
          </button>
        </div>
      </div>
    );
  }
}

AccountPasswordChangeRecommendationModalComponent.propTypes = propTypes;
AccountPasswordChangeRecommendationModalComponent.defaultProps = defaultProps;

const mapDispatchToProps = {
  onModalClose: modalClose,
  onPostPone: postponePasswordChange,
};

export default withRouter(
  connect(null, mapDispatchToProps)(AccountPasswordChangeRecommendationModalComponent)
);
